export default "__VITE_ASSET__d450caed__"